import React, { Component } from 'react';
import { Container, Carousel, Button, Row, Col, Nav } from 'react-bootstrap';
import './all.css'
import logo from '../img/logo.png'
import { Link } from 'react-router-dom';

class Footer extends Component {
    constructor(props) {
        super(props)
        this.state = {}
    }


    render() {
        return (
            <div className='footer'>
                <Row className="justify-content-md-center" style={{ padding: '3% 0' }}>
                    <Col lg={3}>
                        <div>
                            <img src={logo} className="d-block" style={{ width: 40 }} />
                            <div className='footer_label'>一个健康生活的态度和方法</div>
                            <div>400-102-2771</div>
                        </div>
                    </Col>
                    <Col lg={3}>
                        <div className='footer_label'>联系我们</div>
                        <div>公司地址：北京市密云区兴云路98号3幢108</div>
                        <div>联系电话：400-102-2771 </div>
                        <div>电子邮箱：info@raymedy-china.com</div>
                    </Col>
                    {/* <Col  lg={3} className='spaceBetween'>
                        <div>
                            <div className='footer_label'>面向家庭 </div>
                            <div>经脉检测服务</div>
                            <div>润方调理服务 </div>
                            <div>检测与调理服务</div>
                        </div>
                        <div>
                            <div className='footer_label'>面向专业人士 </div>
                            <div>润脉咨询师服务</div>
                        </div>
                        <div>
                            <div className='footer_label'>友情链接</div>
                            <div>荷兰润脉官网</div>
                            <div>亚洲神经反馈</div>
                        </div>
                    </Col>
                    <Col lg={2}>
                        <img src={logo} className="d-inline-block" style={{width:80}}/>
                        <img src={logo} className="d-inline-block" style={{width:80}}/>
                    </Col> */}
                </Row>
                <div className='text-center footer_copy'>
                    <a target="_blank" rel="noopener noreferrer" href='http://beian.miit.gov.cn'>
                        京ICP备18037431号-1
                    </a> &nbsp;
                    北京润脉科技有限公司保留所有权利.
                </div>
            </div>
        )
    }
}

export default Footer;

